module.exports = __webpack_public_path__ + "static/Banjo_Kanna-c5f3fbdfa5a8d68ef0f45904149dcc13.jpg";